import { BaseController } from '@/api/BaseController';
import { RequestOption } from '@/common/http/types';
import { ANY_OBJECT } from '@/types/generic';
import { TableData } from '@/common/types/table';
import { useUrlBuilder } from '@/common/hooks/useUrl';
import ReservationRecordInformation from '@/types/table/reservationRecordInformation';
import { API_CONTEXT } from '../config';

const { buildGetUrl } = useUrlBuilder();

export interface ReservationRecordInformationData extends ReservationRecordInformation {
  __cascade_add_temp_id__?: string | number | undefined;
}

export default class ReservationRecordInformationController extends BaseController {
  static list(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post<TableData<ReservationRecordInformationData>>(API_CONTEXT + '/app/reservationRecordInformation/list', params, httpOptions);
  }
  static view(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.get<ReservationRecordInformationData>(API_CONTEXT + '/app/reservationRecordInformation/view', params, httpOptions);
  }
  static export(params: ANY_OBJECT, fileName: string) {
    return super.download(API_CONTEXT + '/app/reservationRecordInformation/export', params, fileName);
  }
  static import(params: ANY_OBJECT) {
    return super.upload(API_CONTEXT + '/app/reservationRecordInformation/import', params);
  }
  static printUrl(params: ANY_OBJECT) {
    return buildGetUrl(API_CONTEXT + '/app/reservationRecordInformation/print', params);
  }
  static add(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post(API_CONTEXT + '/app/reservationRecordInformation/add', params, httpOptions);
  }
  static update(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post(API_CONTEXT + '/app/reservationRecordInformation/update', params, httpOptions);
  }
  static delete(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post(API_CONTEXT + '/app/reservationRecordInformation/delete', params, httpOptions);
  }
  static deleteBatch(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post(API_CONTEXT + '/app/reservationRecordInformation/deleteBatch', params, httpOptions);
  }
}
